























import { Component, Prop, Vue } from 'vue-property-decorator';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';

import { lccaStore } from '@/store/store';
import AlternativeContainer from '@/modules/lcca/views/components/AlternativeContainer.vue';
import { createNewAlternative } from '@/modules/lcca/lib/createNew';
import { Route } from 'vue-router';
import { BaseProbVariables } from '@/modules/lcca/interfaces/probabilistic';
import { getProbabilisticByName, getUserProbInputs } from '@/modules/lcca/lib/util';
import { createLccaValidations } from '@/modules/lcca/lib/validations';


@Component({
  components: {
    AlternativeContainer,
    PxNumberInput,
    // InputPageWrapper,
    PxTextEntryBox,
    PxTextArea,
    PxDropdown,
  },
})
export default class LccaAlternatives extends Vue {
  @Prop() readonly pxLccaId!: string;

  @Prop() readonly page!: number;

  get scenario() {
    return lccaStore.currentScenario;
  }

  get scenarioImperial() {
    return lccaStore.currentImperial;
  }

  validations() {
    return createLccaValidations(this.scenarioImperial);
  }

  sync() {
    lccaStore.setCurrentScenario(this.scenario);
  }

  save() {
    this.sync();
    lccaStore.saveCurrentScenario();
  }

  get alternatives() {
    return this.scenario.alternatives;
  }

  get userProbInputs() {
    return getUserProbInputs(this.scenarioImperial);
  }

  get trafficProbabilisticInputs() {
    return getProbabilisticByName(this.scenario.probabilistic, BaseProbVariables.annualGrowthTraffic);
  }

  beforeRouteLeave(to: Route, from: Route, next: Function) {
    this.save();
    next();
  }

  createNewAlternative() {
    this.sync();
    let lastAltIndex: number = 0;
    if (this.scenario.alternatives.length > 0) {
      // @ts-ignore
      lastAltIndex = Math.max(this.scenario.alternatives.map((A) => A.index));
    }
    this.scenarioImperial.alternatives.push(createNewAlternative(lastAltIndex));
  }

  mounted() {
  }
}

